if (import.meta.env.MODE === 'development') {
  import('@/assets/index.scss')
}

import {createApp} from 'vue'
import {createPinia} from 'pinia'

// @ts-ignore
import {Formie} from '@/../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib';
import PrimeVue from 'primevue/config'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import AccordionComponent from "@/components/AccordionComponent.vue";
import TabsComponent from "@/components/TabsComponent.vue";
import CatalogMenu from "@/components/CatalogMenu.vue";
import ProductsTable from "@/components/tables/ProductsTable.vue";
import CommentModal from "@/components/modals/CommentModal.vue";
import CartSection from "@/components/products/CartSection.vue";
import ImageGallery from "@/components/products/ImageGallery.vue";
import CartComponent from "@/components/cart/CartPage.vue";
import ItemsCount from "@/components/cart/ItemsCount.vue";
import FavoritePage from "@/components/cart/FavoritePage.vue";
import LoginModal from "@/components/modals/LoginModal.vue";
import FormComponent from "@/components/forms/FormComponent.vue";
import RequisitesPage from "@/components/profile/RequisitesPage.vue";
import RequisitesModal from "@/components/modals/RequisitesModal.vue";
import OrderPage from "@/components/cart/OrderPage.vue";
import {Toast, ToastService} from "primevue";
import OrdersPage from "@/components/profile/OrdersPage.vue";
import AutocompleteInput from "@/components/forms/AutocompleteInput.vue";
import BurgerComponent from "@/components/BurgerComponent.vue";
import SliderComponent from "@/components/SliderComponent.vue";

// @ts-ignore
import {SplideSlide} from '@splidejs/vue-splide';
import {init} from "@/scripts/popularCategories";
import {searchLinksInit} from "@/scripts/searchLinks";
// @ts-ignore
import DynamicCache from "@/components/DynamicCache.vue";
import ky from "ky";
import {useUserStore} from "@/stores/user";
import FiltersTable from "@/components/tables/FiltersTable.vue";
import CategoryButton from "@/components/filters/CategoryButton.vue";
import CookieModal from "@/components/modals/CookieModal.vue";

// @ts-ignore
window.Formie = new Formie()

const app = createApp({
  components: {
    AccordionComponent,
    AutocompleteInput,
    BurgerComponent,
    CartComponent,
    CookieModal,
    ItemsCount,
    CartSection,
    CatalogMenu,
    CategoryButton,
    CommentModal,
    DynamicCache,
    FavoritePage,
    FiltersTable,
    FormComponent,
    ImageGallery,
    LoginModal,
    OrderPage,
    OrdersPage,
    ProductsTable,
    RequisitesModal,
    RequisitesPage,
    SliderComponent,
    SplideSlide,
    TabsComponent,
    Toast,
  },
  setup() {
    (async () => {
      try {
        const userStore = useUserStore()
        const response = await ky<TUserResponse>('/users')

        const detail = await response.json()

        // @ts-ignore
        window.csrfTokenName = detail.csrfTokenName;
        // @ts-ignore
        window.csrfTokenValue = detail.csrfTokenValue;

        userStore.authUser(detail.user);
      } catch (_) {
        // empty
      } finally {
      }
    })();
  },
  mounted() {
    searchLinksInit()
  }
})
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(PrimeVue, {unstyled: true})
app.use(ToastService)

app.mount('#app')

window.addEventListener('beforeunload', function (event) {
  event.stopImmediatePropagation();
});

type TUserResponse = {
  user: string | null,
  csrfTokenName: string,
  csrfTokenValue: string,
}

const hydrate = () => {
  const form = document.querySelector('.login-form__profile')

  form?.addEventListener('onAfterFormieSubmit', (e) => {
    e.preventDefault()

    setTimeout(() => {
      window.location.replace(window.location.href)
    }, 0)
  });
}
init()

hydrate()
